export default "__VITE_PUBLIC_ASSET__fe2c596d__"